// src/app/flexible-store.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FlexibleStoreService {
  private store: Map<string, any> = new Map();

  constructor() {}

  /** Store any value under a key */
  set(key: string, value: any): void {
    this.store.set(key, value);
  }

  /** Retrieve value by key */
  get(key: string): any {
    return this.store.get(key) || null;
  }

  /** Remove a key */
  remove(key: string): void {
    this.store.delete(key);
  }

  /** Clear all stored values */
  clear(): void {
    this.store.clear();
  }
}
